export default __webpack_public_path__ + "static/anywhere-c319808490a1e4ce520f67d20fe3395b.svg";